import { create } from "zustand";
import { operationalDateKey } from "@/lib/operational-date";

/** The dispatch-local date the planner is viewing on the run board. Scopes the
 *  trip query (planned runs for the day); undated MANUAL/active trips stay
 *  visible regardless (server filter is inclusive of null). */
interface DispatchDateState {
  /** "YYYY-MM-DD" in the dispatch-local timezone; empty until it is known. */
  selectedDate: string;
  setSelectedDate: (date: string) => void;
  stepDays: (delta: number) => void;
  resetToToday: (timeZone?: string | null) => void;
}

function shiftDate(date: string, delta: number): string {
  // Pure calendar math via UTC midnight to avoid DST drift on the date string.
  const utc = new Date(`${date}T00:00:00Z`);
  utc.setUTCDate(utc.getUTCDate() + delta);
  return utc.toISOString().slice(0, 10);
}

export const useDispatchDateStore = create<DispatchDateState>((set) => ({
  selectedDate: "",
  setSelectedDate: (date) => set({ selectedDate: date }),
  stepDays: (delta) =>
    set((state) =>
      state.selectedDate
        ? { selectedDate: shiftDate(state.selectedDate, delta) }
        : state
    ),
  resetToToday: (timeZone) => {
    const selectedDate = operationalDateKey(new Date(), timeZone);
    if (selectedDate) set({ selectedDate });
  },
}));
